<template>
    <div class="modal-wrapper">
      <!-- Overlay -->
      <transition name="fade">
        <div v-if="isOpen" class="overlay" @click.self="close"></div>
      </transition>
  
      <!-- Drawer (always in DOM) -->
      <div class="drawer" :class="{ open: isOpen }">
        <h2>Drawer</h2>
        <p>This drawer slides in AND out from the left.</p>
        <button @click="close">Close</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: { isOpen: Boolean },
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
  </script>
  
  <style>
  .modal-wrapper {
    position: relative;
  }
  
  /* Overlay fade */
  .overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.5);
    z-index: 10;
  }
  .fade-enter-active,
  .fade-leave-active { transition: opacity 0.25s ease; }
  .fade-enter-from, .fade-leave-to { opacity: 0; }
  .fade-enter-to, .fade-leave-from { opacity: 1; }
  
  /* Drawer slide */
  .drawer {
    position: fixed;
    top: 0;
    right: 0;
    width: 320px;
    height: 100%;
    background: #fff;
    padding: 20px;
    box-shadow: -2px 0 10px rgba(0,0,0,0.3);
    transform: translateX(100%);
    transition: transform 0.35s ease-in-out;
    z-index: 20;
  }
  .drawer.open {
    transform: translateX(0);
  }
  </style>
  